import { defineNuxtPlugin, useRuntimeConfig } from '#imports'
import { register } from '@teamhanko/hanko-elements'
import { hankoElementsOptions, setHankoClient } from '~/composables/useHankoClient'

export default defineNuxtPlugin(async nuxtApp => {
  const config = useRuntimeConfig()
  const apiUrl = config.public.HANKO_API_URL
  if (!apiUrl) return

  const { hanko } = await register(apiUrl, hankoElementsOptions)
  setHankoClient(hanko)
  nuxtApp.provide('hanko', hanko)
})
